import { useState, useEffect } from "react";
import "../assets/css/Team.css";
import ClientModal from "./RegisterClientModal";
import { fetchWithToken } from "../utils/fetchWithToken";
import { useNavigate } from "react-router-dom";

function Team() {
  const [showValues, setShowValues] = useState(true);
  const [showClientModal, setShowClientModal] = useState(false);
  const [clients, setClients] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();
  const selectedClientId = sessionStorage.getItem("REACT_APP_AGENCY_ID");

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await fetchWithToken(
        `https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/clients/list`
      );

      const data = await response.json();

      const clientsRaw = data?.clients || [];
      const filteredClients = clientsRaw.filter(client => client.agencyId === selectedClientId);

      const clientMap = {};

      filteredClients.forEach((cliente) => {
        const rawName = cliente.nome?.trim();
        if (!rawName) return;

        if (!clientMap[rawName]) {
          clientMap[rawName] = {
            id: cliente._id,
            name: rawName,
            campaignCount: 0,
          };
        }

        clientMap[rawName].campaignCount += 1;
      });

      const clientsList = Object.values(clientMap);

      setClients(clientsList);
      setIsLoaded(true);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error.message);
      setIsLoaded(true);
    }
  };

  const toggleValues = () => {
    setShowValues(!showValues);
  };

  const handleSaveClient = (clientData) => {
    alert(`Cliente ${clientData.name} cadastrado com sucesso!`);
  };

  return (
    <>
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div className="header-content">
            <div className="header-title">Homepage</div>
            <div className="header-subtitle">Monitore seus projetos aqui</div>
          </div>
        </div>

        <div className="clients-section">
          <div className="clients-header">
            <div className="clients-title-container">
              <div className="clients-title">Seus clientes ativos</div>
              <div className="clients-subtitle">
                Confira os detalhes dos bondes mais recentes
              </div>
            </div>
            {isLoaded && clients.length === 0 ? ('') :
              (
                <button
                  className="add-client-button"
                  onClick={() => setShowClientModal(true)}
                >
                  Cadastrar Cliente
                </button>)}
          </div>

          <div className="clients-list-container">
            <div className="clients-list">
              {isLoaded && clients.length === 0 ? (
                <div className="empty-state">
                  <div className="frame">
                    <div className="si-alert-duotone">
                      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="80" height="80" rx="40" fill="#C6DCFF" />
                        <path d="M36.6738 22.2733L20.2052 49.767C19.8658 50.3551 19.6864 51.0218 19.6846 51.7007C19.6828 52.3797 19.8588 53.0472 20.195 53.6371C20.5312 54.227 21.016 54.7185 21.6011 55.063C22.1862 55.4074 22.8512 55.5927 23.5302 55.6003H56.4675C57.1467 55.5933 57.8122 55.4085 58.3977 55.0643C58.9832 54.72 59.4683 54.2283 59.8047 53.6382C60.141 53.0481 60.3169 52.3802 60.3147 51.701C60.3126 51.0218 60.1325 50.355 59.7925 49.767L43.3262 22.2733C42.9798 21.7015 42.4918 21.2287 41.9094 20.9005C41.3269 20.5723 40.6697 20.3999 40.0012 20.3999C39.3326 20.3999 38.6754 20.5723 38.0929 20.9005C37.5105 21.2287 37.0225 21.7015 36.6762 22.2733" fill="#EFF5FF" />
                        <path d="M39.9988 47.4337H40.0175M39.9988 33.4337V40.4337M36.6738 22.2733L20.2052 49.767C19.8658 50.3551 19.6864 51.0218 19.6846 51.7007C19.6828 52.3797 19.8588 53.0472 20.195 53.6371C20.5312 54.227 21.016 54.7185 21.6011 55.063C22.1862 55.4074 22.8512 55.5927 23.5302 55.6003H56.4675C57.1467 55.5933 57.8122 55.4085 58.3977 55.0643C58.9832 54.72 59.4683 54.2283 59.8047 53.6382C60.141 53.0482 60.3169 52.3802 60.3147 51.701C60.3126 51.0218 60.1325 50.355 59.7925 49.767L43.3262 22.2733C42.9798 21.7015 42.4918 21.2287 41.9094 20.9005C41.3269 20.5723 40.6697 20.3999 40.0012 20.3999C39.3326 20.3999 38.6754 20.5723 38.0929 20.9005C37.5105 21.2287 37.0225 21.7015 36.6762 22.2733" stroke="#4285F3" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <p className="stat-label mb-25x">
                      Entre em contato com nossa equipe para configurar sua <br />
                      conta e começar a acompanhar seus resultados.
                    </p>
                    <a href="https://wa.me/5511914885206" target="_blank"
                      className="add-client-button"
                    >
                      Entrar em contato
                    </a>
                  </div>
                </div>
              ) : (
                clients.map((client, index) => (
                  <div className="client-row" key={index}>
                    <div className="client-info-card">
                      <div className="client-info-content">
                        <div className="client-name">{client.name}</div>
                      </div>
                    </div>
                    <div className="client-action-container">
                      <button
                        className="client-action-button"
                        onClick={() => {
                          localStorage.setItem("selectedClientName", client.name);
                          localStorage.setItem("selectedClientId", client.id);
                          navigate("/insights")
                        }}
                      >
                        <img
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/6bb20f8450894e5431f2bae869d78c6b29ad9c32?placeholderIfAbsent=true"
                          alt="View details"
                        />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>

      <ClientModal
        isOpen={showClientModal}
        onClose={() => setShowClientModal(false)}
        onSave={handleSaveClient}
      />
    </>
  );
}

export default Team;
